import { Component, Input } from '@angular/core';
import { playIcon, categoryIcon } from '../../app-icons';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LearningPathModel } from 'src/app/models/learning-paths/learning-path.model';

@Component({
  selector: 'app-learning-path-card',
  templateUrl: './learning-path-card.component.html',
  styleUrls: ['./learning-path-card.component.scss'],
  standalone: false
})
export class LearningPathCardComponent {
  @Input()
  learningPath!: LearningPathModel;

  // getCategoryIcon() {
  //   return this.sanitized.bypassSecurityTrustHtml(categoryIcon);
  // }

  // getPlayIcon() {
  //   return this.sanitized.bypassSecurityTrustHtml(playIcon);
  // }

  getCardLink() {
    return `/learning-paths/${this.learningPath.id}`
  }

  constructor(
    private sanitized: DomSanitizer,
    private router: Router,
    public translateService: TranslateService
  ) {}
}
